<ra-modal
    #mainModal
    [title]="'document.edit.footerEditor.title' | translate"
    [size]="'xlarge'"
    [animation]="'slide-right'"
    [backdrop]="false"
    (close)="close.emit()"
>
    <div class="footer-twopane">
        <!-- Esquerda: campos -->
        <div class="pane-fields">
            <div class="pane-head">
                <span class="pane-title">{{ 'document.edit.footerEditor.fieldsTitle' | translate }}</span>
                <span class="footer-badge">
                    {{ 'document.edit.footerEditor.countBadge' | translate: { count: visibleCount(), max: MAX_VISIBLE } }}
                </span>
            </div>

            <div class="footer-items">
                @for (item of editableItems(); track item.fieldId) {
                    <div class="footer-card" [class.is-visible]="item.isVisible">
                        <div class="footer-card-head" (click)="onCardHeadClick(item)">
                            <div class="footer-card-icon" [class.active]="item.isVisible">
                                <ra-icon
                                    [icon]="iconFor(item)"
                                    [varColor]="item.isVisible ? 'accentBlue' : 'contentSecondary'"
                                    [size]="20"
                                />
                            </div>

                            <div class="footer-card-text">
                                <span class="footer-card-title">{{ titleFor(item) }}</span>
                                <span class="footer-card-desc">{{ descFor(item) }}</span>
                            </div>

                            @if (item.canHide && controlFor(item.fieldId)) {
                                <ra-switch [formControl]="controlFor(item.fieldId)" />
                            }
                        </div>

                        @if (item.isVisible) {
                            <div class="footer-card-input">
                                <ra-link-token-composer
                                    [text]="textValue(item)"
                                    [linkTagName]="linkTagNameOf(item)"
                                    [limitChar]="limitCharOf(item)"
                                    [placeholder]="'document.edit.footerEditor.inputPlaceholder' | translate"
                                    (valueChange)="onComposerChange(item.fieldId, $event)"
                                />
                            </div>
                        }
                    </div>
                }
            </div>
        </div>

        <!-- Direita: pré-visualização + onde aplicar + salvar -->
        <div class="pane-preview">
            <span class="pane-title">{{ 'document.edit.footerEditor.previewTitle' | translate }}</span>

            <div class="preview-sheet">
                <div class="preview-skeleton">
                    <span class="sk-line"></span>
                    <span class="sk-line short"></span>
                </div>

                <div class="preview-foot">
                    @if (previewLines().length) {
                        <div class="preview-grid">
                            @for (line of previewLines(); track $index) {
                                <span class="preview-line">
                                    <ra-icon [icon]="line.icon" varColor="contentSecondary" [size]="14" />
                                    <span class="preview-line-text">{{ line.text }}</span>
                                </span>
                            }
                        </div>
                    } @else {
                        <span class="preview-empty">{{ 'document.edit.footerEditor.previewEmpty' | translate }}</span>
                    }
                    <span class="preview-page">{{ 'document.edit.footerEditor.previewPage' | translate }}</span>
                </div>
            </div>

            <div class="pane-foot">
                <ra-button
                    [label]="'common.save' | translate"
                    [type]="'primary'"
                    [loading]="loading()"
                    [disabled]="!canAct()"
                    (click)="confirmSave()"
                />
            </div>
        </div>
    </div>
</ra-modal>
